import './App.css';
import 'normalize.css/normalize.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/datetime2/lib/css/blueprint-datetime2.css';

import { QueryClientProvider } from '@tanstack/react-query';
import * as React from 'react';
import { Provider } from 'react-redux';

import { store } from './configureApp';
import ErrorBoundary from './ErrorBoundary';
import { queryClient } from './queries';
import Router from './Router';

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <div className="App">
            <ErrorBoundary>
              <Router />
              <a id="vms-download-anchor-7f3c9a2e" hidden />
            </ErrorBoundary>
          </div>
        </QueryClientProvider>
      </Provider>
    );
  }
}

export default App;
